export default class Show {
    static init(): void {
        this.toggle();
    }

    static toggle(): void {
        const toggles = document.querySelectorAll('[data-toggle="show"][data-target][data-target-section]');

        toggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const dataTarget = toggle.getAttribute('data-target');
                if (!dataTarget) return;

                const dataSection = toggle.getAttribute('data-target-section');
                if (!dataSection) return;
                const section = document.querySelector('[data-section="' + dataSection + '"]');

                const targets = section?.querySelectorAll('[data-show]');
                if (!targets) return;

                toggles.forEach((toggle) => {
                    if (toggle !== e.target) {
                        toggle.setAttribute('data-active', 'false');
                    }
                });
                toggle.setAttribute('data-active', 'true');

                targets.forEach((target) => {
                    if (target.getAttribute('data-show') !== dataTarget) {
                        target.setAttribute('data-active', 'false');
                    } else {
                        target.setAttribute('data-active', 'true');
                    }
                });

                const title = toggle.getAttribute('data-title');
                if (title) {
                    const titleTarget = section?.querySelector('[data-show-title]');
                    if (titleTarget) {
                        titleTarget.innerHTML = title;
                    }
                }
            });

            if (toggle.hasAttribute('data-click-first')) {
                toggle.dispatchEvent(new Event('click'));
            }

        });
    }

}
